module.exports = __webpack_public_path__ + "static/img/681d8739gy1g3km3fh3pcj218a1n21kx@2x.df792f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/center/681d8739gy1g3km3fh3pcj218a1n21kx@2x.png
// module id = NodQ
// module chunks = 1